import { firmware, lastUpdate, name, reachable, routerId, setupDate } from '~/helpers/fields-description';
import { MullerModule } from '~/models/modules/muller/MullerModule.model';

export class NMH extends MullerModule {
    hasOperationReset = false;

    muller_type?: string;
    firmware_2?: string;
    muller_model?: number;
    reachable?: boolean;
    router_id?: string;
    brand_name?: string;
    heater_nature?: string;
    power?: number;

    specFieldsOrder = [
        'macAddress',
        'name',
        'type',
        'firmware',
        'mullerType',
        'routerId',
        'lastSetup',
        'lastSeen',
        'customer',
        'command',
        'customer2',
        'command2',
        'room',
    ];

    get fieldName() {
        return name(this.name);
    }
    get fieldSetupDate() {
        return setupDate(this.setup_date || this.date_setup);
    }
    get fieldFirmware() {
        return firmware(this.firmware_2);
    }
    get fieldLastUpdate() {
        return lastUpdate(this.last_fw_update);
    }
    get fieldRouterId() {
        return routerId(this.router_id);
    }
    get fieldReachable() {
        return reachable(this.reachable);
    }
    get fieldMullerType() {
        return { key: 'mullerType', value: this.muller_type, type: 'string' };
    }
    get fieldRoom() {
        return { key: 'room', value: this.room, class: this.room === 'N/A' ? 'error--text' : '' };
    }
    get fieldModel() {
        return { key: 'model', value: this.muller_model ? hexaToModel(this.muller_model.toString(16)) : 'N/A', type: 'string' };
    }
    get fieldBrandName() {
        return { key: 'brandName', value: this.brand_name, type: 'string' };
    }
    get fieldHeaterNature() {
        return { key: 'heaterNature', value: this.heater_nature, type: 'string' };
    }
    get fieldDevicePower() {
        return { key: 'devicePower', value: this.power, type: 'number' };
    }

}

function hexaToModel(hexaNumber: string) {
    return (hexaNumber === '0' ? 'Unknown' : 'M' + hexaNumber.toUpperCase());
}
